import React, { useState } from "react";
import styled from "styled-components";
import { useFlags } from "launchdarkly-react-client-sdk";

import { Icon } from "@paclife/plds.icon";
import { Colors, Spacing, Radii, Shadows } from "@paclife/plds.tokens";

import Typography from "common/Typography/Typography";
import OutsideClickWrapper from "common/OutsideClickWrapper/OutsideClickWrapper";

const Wrapper = styled.div`
    position: relative;
`;

const Divider = styled.hr`
    height: 1px;
    width: 100%;
    background-color: ${Colors.neutral200};
    border: none;
    margin: ${Spacing[4]} auto;
`;

const Menu = styled.div`
    width: 154px;
    background-color: ${Colors.neutral0};
    box-shadow: ${Shadows.medium};
    padding: 12px 16px;
    border-radius: ${Radii.rounded};
    position: absolute;
    top: 24px;
    z-index: 100;
`;

const Text = styled(Typography)`
    white-space: nowrap;
`;

// Temparary Fix before PLDS Icon Button is fixed
const IconButton = styled.span`
    cursor: pointer;
    margin-right: ${Spacing[8]};
    display: flex;
    align-items: center;
    .icon-right-margin {
        margin-right: ${Spacing[4]};
    }
    :not(:first-of-type) {
        margin-top: ${Spacing[8]};
    }
`;

const OverflowMenu = ({ icon, color, onClick, menu }) => {
    const [overflowMenu, setOverflowMenu] = useState(false);
    const { rsdUpReadonlyaccessEn } = useFlags();

    const handleClick = () => {
        if (rsdUpReadonlyaccessEn) {
            return;
        }
        if (icon !== "overflowMenuVertical") {
            onClick();
        } else {
            setOverflowMenu(true);
        }
    };

    return (
        <Wrapper>
            {overflowMenu && (
                <OutsideClickWrapper callback={() => setOverflowMenu(false)}>
                    <Menu>
                        {menu.map(({ icon, color, action, onClick }) => (
                            <React.Fragment key={action}>
                                {icon === "delete" && <Divider />}
                                <IconButton
                                    onClick={onClick}
                                    data-track="analytics"
                                    data-bname={`${action}-icon-button`}
                                >
                                    <Icon
                                        name={icon}
                                        color={rsdUpReadonlyaccessEn ? Colors.disabled : color}
                                        width={16}
                                        className="icon-right-margin"
                                    />
                                    <Text variant="caption">{action}</Text>
                                </IconButton>
                            </React.Fragment>
                        ))}
                    </Menu>
                </OutsideClickWrapper>
            )}
            <IconButton
                onClick={handleClick}
                data-track="analytics"
                data-bname="overflow-icon-button"
            >
                <Icon name={icon} color={rsdUpReadonlyaccessEn ? Colors.disabled : color} width={20} />
            </IconButton>
        </Wrapper>
    );
};

export default OverflowMenu;
